export default __webpack_public_path__ + "static/media/alert--yellow.75a25313.svg";